import { ReactNode, useState } from 'react';
import classNames from 'classnames';
import { ImUser } from '@react-icons/all-files/im/ImUser';
import { ImageWithLoader } from './ImageWithLoader';

export const sizes = {
  small: 'h-10 w-10 mr-2',
  medium: 'h-14 w-14',
  large: 'h-40 w-40',
  xl: 'h-52 w-52',
};

interface AvatarProps {
  profilePictureUrl?: string | null;
  altText?: string;
  pictureSize?: keyof typeof sizes;
  className?: string;
}

export function DefaultUserImage() {
  return (
    <div className="bg-gray-300 h-full w-full flex justify-center items-center">
      <ImUser className="text-white w-3/4 h-3/4" style={{ paddingLeft: 1 }} />
    </div>
  );
}

export function Avatar({ pictureSize = 'small', ...props }: AvatarProps) {
  const [imageError, setImageError] = useState(false);

  return (
    <div
      className={classNames(
        'flex rounded-full justify-center items-center overflow-hidden border border-gray-200',
        sizes[pictureSize],
        props.className,
      )}
    >
      {imageError || !props.profilePictureUrl ? (
        <DefaultUserImage />
      ) : (
        <ImageWithLoader
          className="object-cover w-full h-full"
          src={props.profilePictureUrl}
          alt={props.altText}
          onError={() => setImageError(true)}
        />
      )}
    </div>
  );
}
